import omit from 'lodash/omit';
import type { SubmissionDetailsDto } from '../../../../../api/submissions/submissions.api.types';
import { toOptionTerms } from './quoteOptionsModel';

/** The ids an option never stores in its terms: the submission it sits on supplies them. */
const IDS_OUTSIDE_TERMS = ['accountId', 'agencyId', 'submissionId'] as const;

/**
 * The terms of a P100 or P250 option: the cart's add body without the account, agency and
 * submission ids, in the form the wire carries.
 */
export const toOptionTermsWithoutIds = (payload: object): unknown =>
  toOptionTerms(omit(payload, IDS_OUTSIDE_TERMS));

/** The renewal fields the quote request carries, read from the submission. */
export const renewalFieldsOf = (
  submission:
    | Pick<
        SubmissionDetailsDto,
        'isRenewal' | 'expiringPolicyId' | 'expiringPolicyNumber'
      >
    | undefined
) => ({
  isRenewal: submission?.isRenewal ?? false,
  renewalPolicyId: submission?.expiringPolicyId,
  renewalPolicyNumber: submission?.expiringPolicyNumber,
});
